import _ from 'lodash'

export function deepFreeze (o) {
  if (_.isNil(o)) return o

  Object.freeze(o)

  const oIsFunction = typeof o === 'function'
  const hasOwnProp = Object.prototype.hasOwnProperty

  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (hasOwnProp.call(o, prop) &&
    (oIsFunction ? prop !== 'caller' && prop !== 'callee' && prop !== 'arguments' : true) &&
    o[prop] !== null &&
    (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
    !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop])
    }
  })

  return o
}

export function firstOrDefault (array, predicate, def) {
  if (!array) return def
  if (_.isArrayLike(array)) {
    for (let index = 0; index < array.length; index++) {
      const element = array[index]
      if (!predicate || predicate(element, index, array)) {
        return element
      }
    }
  } else {
    for (const key in array) {
      const element = array[key]
      if (!predicate || predicate(element, key, array)) {
        return element
      }
    }
  }
  return def
}

export function isEmptyString (text) {
  return text === undefined || text === null || text === '' || (text instanceof String && text.length === 0)
}

export function isNotEmptyString (text) {
  return !isEmptyString(text)
}

export function isWhitespaceString (text) {
  return isEmptyString(text) || /^\s+$/.test(text)
}

export function isNotWhitespaceString (text) {
  return !isWhitespaceString(text)
}

export function crossJoin (arrays, filter) {
  if (!arrays?.length) return []
  // console.log('crossJoin', arrays, filter)
  const rowsCount = arrays.reduce((prevCount, currArr) => prevCount * currArr.length, 1)
  const colsCount = arrays.length
  const result = []
  for (let rowIndex = 0; rowIndex < rowsCount; rowIndex++) {
    const row = new Array(colsCount)
    let itemIndex = rowIndex
    for (let colIndex = 0; colIndex < colsCount; colIndex++) {
      const array = arrays[colIndex]
      row[colIndex] = array[itemIndex % array.length]
      itemIndex = Math.floor(itemIndex / array.length)
    }
    if (!filter || filter(row, rowIndex, arrays)) {
      result.push(row)
    }
  }
  return result
}

export function reset (target, init) {
  const getInitValue = init ? (init instanceof Function ? init : key => init[key]) : key => null
  for (const key in target) {
    target[key] = getInitValue(key)
  }
  return target
}

export function roundGrain (value, grain) {
  const exponentialGrain = grain.toExponential()
  const match = /^(\d+)(\.(\d+))?e([+-])(\d+)$/.exec(exponentialGrain)
  if (!match) {
    throw new Error(`无法识别指定的粒度(${grain})的科学计数法:${exponentialGrain}`)
  }
  const factorE = (match[3] ? match[3].length : 0) + (match[4] === '-' ? parseInt(match[5]) : 0)
  const factor = Math.pow(10, factorE)
  const intGrain = grain * factor
  return Math.round((value * factor) / (intGrain)) * grain
}

export function clampNumber (value, { min, max, excludeMin, excludeMax, grain }) {
  if (value < min) {
    return excludeMin ? (min + grain) : min
  } else if (value > max) {
    return excludeMax ? (max - grain) : max
  } else {
    return value
  }
}
